import { render, staticRenderFns } from "./hero-slider.vue?vue&type=template&id=5b47160a&"
import script from "./hero-slider.vue?vue&type=script&lang=js&"
export * from "./hero-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports